module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"row\" style='")
    ; __append(escapeFn( mobileDesignerStyle ))
    ; __append("'>\r\n    <div class=\"col-md-3 prop-sublabel\">Over</div>\r\n    <div class=\"col-md-4 nopadding\" >\r\n        <input id=\"advancedBgColorOverPicker\" name=\"advancedBgColorOver\" type=\"color\" value=\"")
    ; __append(escapeFn( advancedBgColorOver ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n        <input id=\"advancedBgColorOver\" name=\"advancedBgColorOver\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( advancedBgColorOver ))
    ; __append("\" />\r\n    </div>\r\n    <div class=\"col-md-5 nopadding\" >\r\n        <input id=\"advancedBgGradientColorOverPicker\" name=\"advancedBgGradientColorOver\" type=\"color\" value=\"")
    ; __append(escapeFn( advancedBgGradientColorOver ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n        <input id=\"advancedBgGradientColorOver\" name=\"advancedBgGradientColorOver\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( advancedBgGradientColorOver ))
    ; __append("\" />\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-3 prop-sublabel\">Down</div>\r\n    <div class=\"col-md-4 nopadding\" >\r\n        <input id=\"advancedBgColorDownPicker\" name=\"advancedBgColorDown\" type=\"color\" value=\"")
    ; __append(escapeFn( advancedBgColorDown ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n        <input id=\"advancedBgColorDown\" name=\"advancedBgColorDown\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( advancedBgColorDown ))
    ; __append("\" />\r\n    </div>\r\n    <div class=\"col-md-5 nopadding\" >\r\n        <input id=\"advancedBgGradientColorDownPicker\" name=\"advancedBgGradientColorDown\" type=\"color\" value=\"")
    ; __append(escapeFn( advancedBgGradientColorDown ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n        <input id=\"advancedBgGradientColorDown\" name=\"advancedBgGradientColorDown\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( advancedBgGradientColorDown ))
    ; __append("\" />\r\n    </div>\r\n</div>")
  }
  return __output;

}